import React, { Component } from 'react';
import { Icon, Table, Row, Col, Form, DatePicker, Input, Button, Spin, Modal, Checkbox, Radio, TimePicker, Cascader, Card } from 'antd';
import { injectIntl } from 'react-intl';
import axios from 'axios';
import { filter, last, isEqual, isNil } from 'lodash';
import moment from 'moment';
import IntlMessages from '../../../../../util/IntlMessages';
import DateTimeFormat from '../../../../../Constants/DateTimeFormat';
import Language from '../../../../../Constants/Language';
import Local from '../../../../../Constants/Local';

const { Column } = Table;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const { Search } = Input;
class BasicInfo extends Component {

    constructor(prop) {
        super(prop);

        this.state = {
            optPlainEns: [
                { label: 'Employee', value: 'Employee' },
                { label: 'Contractor', value: 'Contractor' },
            ],
            optPlainThs: [
                { label: 'พนักงาน', value: 'Employee' },
                { label: 'คู่ธุรกิจ', value: 'Contractor' },
            ],
            optSites: [],
            observerSearchModalVisible: false,
            isObserverSearchModalLoading: false,
            observerSearchDatas: [],
        }
    }

    componentDidMount() {

    }

    validate = () => {
        let isPass = true;
        const observationTrn = this.props.observationTrn;

        if (!observationTrn.observation_Date
            || !observationTrn.observation_Time
            || (!observationTrn.plainSelecteds || observationTrn.plainSelecteds.length === 0)
            || !observationTrn.shift
            || (!observationTrn.areaTrees || observationTrn.areaTrees.length === 0)
            || (!observationTrn.siteTrees || observationTrn.siteTrees.length === 0)) {
            isPass = false;
        }

        return isPass;
    }

    setOptSites = (areaIdSelected, areaDatas) => {
        const rootSubAreas = filter(areaDatas, { Parentid: areaIdSelected });

        const optSites = rootSubAreas.map((item) => {
            return {
                value: item.PKAreaID,
                label: item.Name,
                children: []
            }
        });

        optSites.forEach((area) => {
            this.setChildOfOptSubAreas(area, areaDatas, 1);
        });

        this.setState({ optSites: optSites });
    }

    onOptAreasChange = (values) => {
        const observationTrn = this.props.observationTrn;
        if (!isEqual(observationTrn.areaTrees, values)) {
            this.props.setObservationTrnFields([
                {
                    value: values,
                    fieldName: "areaTrees"
                },
                {
                    value: [],
                    fieldName: "siteTrees"
                },
            ]);

            if (values && values.length > 0) {
                const areaId = last(values);
                this.setOptSites(areaId, this.props.areaDatas);
            }
            else {
                this.setState({ optSites: [] });
            }
        }
    }

    setChildOfOptSubAreas = (area, areaDatas, ordering) => {

        if (ordering < 20) {
            const childAreas = filter(areaDatas, { Parentid: area.value });

            area.children = childAreas.map((item) => {
                return {
                    value: item.PKAreaID,
                    label: item.Name,
                    children: []
                }
            });

            area.children.forEach(child => {
                this.setChildOfOptSubAreas(child, areaDatas, ordering + 1);
            });
        }
    }

    disabledDate = (current) => {
        const startOfMonth = this.props.minObservationDate ? this.props.minObservationDate : moment().startOf('month');
        const endOfMonth = this.props.maxObservationDate ? this.props.maxObservationDate : moment().endOf('month');
        console.debug("disabledDate", {
            current: current.format('YYYY-MM-DD hh:mm'),
            startOfMonth: startOfMonth.format('YYYY-MM-DD hh:mm'),
            minObservationDate: this.props.minObservationDate.format('YYYY-MM-DD hh:mm'),
            maxObservationDate: this.props.maxObservationDate.format('YYYY-MM-DD hh:mm'),
        });
        return current < startOfMonth || current > endOfMonth;
    }

    openObserverSearchModal = () => {
        this.setState({
            observerSearchModalVisible: true,
        });
    }

    onObserverSearchSelect = (selectedUser) => {
        this.props.setObservationTrnFields([
            {
                value: selectedUser.userId,
                fieldName: "userId"
            },
            {
                value: { ...selectedUser },
                fieldName: "userData"
            },
        ]);

        this.setState({
            observerSearchModalVisible: false,
        });
    }

    onObserverSearchCancel = () => {
        this.setState({
            observerSearchModalVisible: false,
        });
    }

    onObserverSearchData = (keyword) => {
        this.setState({ isObserverSearchModalLoading: true }, () => {
            this.getTokenHeader().then((tokenHeader) => {

                let lang = Language.TH;
                if (this.props.intl.locale === Local.EN) {
                    lang = Language.EN;
                }

                axios.get("api/CTObservationTransactionV2/OptUserResponseSearch?keyword=" + keyword + "&lang=" + lang + "&companyID=" + this.props.observationTrn.companyID, tokenHeader).then(userDataResp => {
                    this.setState({
                        isObserverSearchModalLoading: false,
                        observerSearchDatas: userDataResp.data
                    });
                });
            });
        });
    }

    getTokenHeader = () => {
        var $getToken = new Promise((resolve, reject) => {
            axios.get('auth/token').then((res) => {
                const tokenHeader = { headers: { "Authorization": "Bearer " + res.data } };
                resolve(tokenHeader);
            }).catch(err => {
                if (401 === err.response.status) {
                    localStorage.setItem("ObsReqRedirectAfterLogin", "ObsReqRedirectAfterLogin");
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const local = this.props.intl ? this.props.intl.locale : Local.TH;
        const isReadonly = this.props ? this.props.isReadonly : true;
        const validated = this.props ? this.props.validated : false;
        const observationTrn = this.props.observationTrn ? this.props.observationTrn : {};

        var observerName = "";
        if (observationTrn && observationTrn.userData && observationTrn.userData.userId) {
            if (local === Local.EN) {
                observerName = observationTrn.userData.fullNameEN;
            }
            else {
                observerName = observationTrn.userData.fullNameTH;
            }
        }

        let optPlains = this.state.optPlainEns;
        if (this.props.intl && this.props.intl.locale === Local.TH) {
            optPlains = this.state.optPlainThs;
        }

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        const sortText = (aText, bText) => {
            if (aText === bText) return 0
            else if (isNil(aText)) return 1
            else if (isNil(bText)) return -1
            else
                return aText.toLowerCase().localeCompare(bText.toLowerCase())
        }

        return (<Card size={<IntlMessages id="basic.topic_step1_basic_info" />}>
            <div className='basic'>
                <div className="basic_form">
                    <div style={{ width: "100%" }}>
                        <div className="basic_div_observer">
                            <IntlMessages id="basic.observer" />
                            <FormItem {...formItemLayout} validateStatus={(validated && !observationTrn.userID) ? "error" : "success"}>
                                <Search placeholder={"No selected value."} enterButton
                                    readOnly={true}
                                    value={observerName}
                                    onSearch={this.openObserverSearchModal}
                                    disabled={isReadonly}
                                />
                            </FormItem>
                        </div>
                        <div className="basic_div_date">
                            <IntlMessages id="basic.observation_date" />
                            <FormItem {...formItemLayout} validateStatus={(validated && !observationTrn.observation_Date) ? "error" : "success" }>
                                <DatePicker
                                    className="basic_date"
                                    format={DateTimeFormat.Date}
                                    disabledDate={this.disabledDate}
                                    disabled={isReadonly}
                                    value={observationTrn.observation_Date ? moment(observationTrn.observation_Date, DateTimeFormat.BackendDate) : undefined}
                                    onChange={(dateMoment) => {
                                        if (dateMoment) {
                                            this.props.setObservationTrnField(dateMoment.format(DateTimeFormat.BackendDate), "observation_Date");
                                        }
                                        else {
                                            this.props.setObservationTrnField(undefined, "observation_Date");
                                        }
                                    }}
                                />
                            </FormItem>
                        </div>
                        <div className="basic_div_time">
                            <IntlMessages id="basic.time" />
                            <FormItem {...formItemLayout} validateStatus={(validated && !observationTrn.observation_Time) ? "error" : "success"}>
                                <TimePicker
                                    className="basic_time"
                                    format="HH:mm"
                                    placeholder="12:00"
                                    inputReadOnly={true}
                                    disabled={isReadonly}
                                    value={observationTrn.observation_Time ? moment(observationTrn.observation_Time, "HH:mm") : undefined}
                                    onChange={(timeMoment, timeString) => {
                                        if (timeMoment) {
                                            this.props.setObservationTrnField(timeString, "observation_Time");
                                        }
                                        else {
                                            this.props.setObservationTrnField(undefined, "observation_Time");
                                        }
                                    }}
                                />
                            </FormItem >
                        </div>
                    </div>
                    <div >
                        <IntlMessages id="basic.type_of_observed_people" />
                        <FormItem {...formItemLayout} validateStatus={(validated && (!observationTrn.plainSelecteds || observationTrn.plainSelecteds.length === 0)) ? "error" : "success"}>
                            < CheckboxGroup options={optPlains} disabled={isReadonly}
                                value={observationTrn.plainSelecteds}
                                onChange={(values) => { this.props.setObservationTrnField(values, "plainSelecteds"); }}
                            />
                        </FormItem >
                    </div>
                    <div >
                        <IntlMessages id="basic.shift" />
                        < FormItem {...formItemLayout} validateStatus={(validated && !observationTrn.shift) ? "error" : "success"}>
                            <RadioGroup disabled={isReadonly}
                                value={observationTrn.shift}
                                onChange={(e) => { this.props.setObservationTrnField(e.target.value, "shift"); }}
                            >
                                <Radio value="Daytime"><IntlMessages id="basic.shift_Daytime" /></Radio>
                                <Radio value="Shift"><IntlMessages id="basic.shift_Shift" /></Radio>
                            </RadioGroup>
                        </FormItem >
                    </div>
                    <div style={{ width: "100%" }}>
                        <IntlMessages id="basic.area" />
                        <FormItem {...formItemLayout} validateStatus={(validated && (!observationTrn.areaTrees || observationTrn.areaTrees.length === 0)) ? "error" : "success"}>
                            <Cascader
                                className="basic_area"
                                options={this.props.optAreas}
                                expandTrigger="hover"
                                placeholder="Please select"
                                disabled={isReadonly}
                                value={observationTrn.areaTrees}
                                onChange={this.onOptAreasChange}
                            />
                        </FormItem >
                    </div>
                    <div >
                        <IntlMessages id="basic.site" />
                        < FormItem {...formItemLayout} validateStatus={(validated && (!observationTrn.siteTrees || observationTrn.siteTrees.length === 0)) ? "error" : "success"}>
                            <Cascader
                                className="basic_site"
                                options={this.state.optSites}
                                onChange={this.ChangeSite}
                                expandTrigger="hover"
                                placeholder="Please select"
                                disabled={isReadonly}
                                value={observationTrn.siteTrees}
                                onChange={(values) => { this.props.setObservationTrnField(values, "siteTrees"); }}
                            />
                        </FormItem >
                    </div>
                </div>
            </div>

            <Modal
                width="90%"
                title={<IntlMessages id="basic.observer" />}
                visible={this.state.observerSearchModalVisible}
                footer={null}
                onCancel={this.onObserverSearchCancel}
            >
                <Spin spinning={this.state.isObserverSearchModalLoading}>
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Search placeholder="Name (EN/TH)" enterButton onSearch={this.onObserverSearchData} />
                        </Col>
                    </Row>
                    <br />
                    <Table dataSource={this.state.observerSearchDatas}
                        size="small"
                        bordered={true}
                        pagination={{ pageSize: 10 }}
                        rowKey="userId">
                        <Column dataIndex="userId" title="" align="center"
                            render={(text, record) => {
                                return <>
                                    <Button size="small" onClick={() => { this.onObserverSearchSelect(record); }}><Icon type="select" /> Select</Button>
                                </>
                            }}
                        />
                        <Column dataIndex="fullNameTH" title="ชื่อ" align="center"
                            sorter={(a, b) => sortText(a.fullNameTH, b.fullNameTH)}
                        />
                        <Column dataIndex="fullNameEN" title="Name" align="center"
                            sorter={(a, b) => sortText(a.fullNameEN, b.fullNameEN)}
                        />
                        {/*<Column dataIndex="company" title="Company" align="left"*/}
                        {/*    sorter={(a, b) => sortText(a.company, b.company)}*/}
                        {/*/>*/}
                        {/*<Column dataIndex="department" title="Department" align="left"*/}
                        {/*    sorter={(a, b) => sortText(a.department, b.department)}*/}
                        {/*/>*/}
                        {/*<Column dataIndex="division" title="Division" align="left"*/}
                        {/*    sorter={(a, b) => sortText(a.division, b.division)}*/}
                        {/*/>*/}
                        <Column dataIndex="email" title="E-Mail" align="left"
                            sorter={(a, b) => sortText(a.email, b.email)}
                        />
                    </Table>
                </Spin>
            </Modal>

        </Card>)
    }

}

export default injectIntl(BasicInfo, { withRef: true });